import type { I18nDict } from '../types.ts'

export const pt: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Definições',
  section_language: 'Idioma',
  section_identity: 'Identidade local',
  section_updates: 'Atualização da app',
  section_notifications: 'Notificações',
  section_theme: 'Tema visual',
  section_backup: 'Cópia de segurança do chat',
  section_privacy_network: 'Privacidade de rede',
  section_media: 'Multimédia',
  section_security: 'Segurança e palavra-passe',
  section_exit: 'Fechar e destruir dados',
  toggle_external_links: 'Receber e visualizar ligações externas',
  hint_external_links: 'Se DESLIGADO: sem pré-visualizações de ligações no chat e URLs externas não podem ser abertas (proteção contra rastreamento de IP).',
  toggle_auto_media: 'Transferência automática de multimédia e documentos',
  hint_auto_media: 'Se DESLIGADO: fotos, vídeos e ficheiros não são transferidos em segundo plano — toque manualmente no chat.',
  toggle_require_unlock: 'Palavra-passe ao abrir a app',
  hint_require_unlock: 'Quando LIGADO, a palavra-passe principal é necessária sempre que abrir o ZION.',
  toggle_wipe_exit: 'Apagar dados ao sair',
  hint_wipe_exit: 'Quando LIGADO, fechar a app limpa a cache temporária da RAM e os dados da sessão.',
  btn_exit: 'Sair',
  btn_delete_all: 'ELIMINAR TODOS OS DADOS',
  btn_lock: 'Bloquear app',
  btn_back: 'Voltar',
  warn_disable_password_title: '⚠️ AVISO',
  warn_disable_password_body: 'Desativar a palavra-passe de abertura significa que qualquer pessoa com o seu dispositivo pode ler as suas mensagens encriptadas. Tem a certeza de que deseja continuar?',
  warn_delete_all_1: 'Deseja realmente destruir toda a base de dados? Esta ação é irreversível.',
  warn_delete_all_2: 'Confirmação final: todos os chats, chaves privadas e definições serão eliminados permanentemente.',
  link_blocked: 'Ligação externa bloqueada (definições de privacidade).',
  lang_welcome_title: 'Bem-vindo ao ZION',
  lang_welcome_sub: 'Escolha o seu idioma',
  lang_continue: 'Continuar',
  settings_language_label: 'Idioma da app',
  auth_unlock_title: 'Desbloquear',
  auth_or_password: '— ou desbloquear com palavra-passe —',
  auth_password_master: 'Palavra-passe principal',
  auth_unlock_btn: 'Desbloquear',
  auth_verifying: 'A verificar…',
  auth_wrong_password: 'Palavra-passe incorreta',
  auth_unlocked: 'Desbloqueado ✓',
  auth_access_title: 'Entrar no ZION',
  auth_beta_spots: 'Beta gratuita · lugares restantes:',
  auth_beta_full: 'Beta cheia ({max} utilizadores). Tente novamente mais tarde.',
  auth_beta_free: 'Beta gratuita · sem licença necessária',
  auth_or_create: '— ou criar uma nova identidade —',
  auth_password_min: 'Palavra-passe (mín. 8 caracteres)',
  auth_password_confirm: 'Confirmar palavra-passe',
  auth_privacy_check: 'Li a',
  auth_privacy_link: 'Política de Privacidade',
  auth_terms_check: 'Aceito os',
  auth_terms_link: 'Termos de Serviço',
  auth_password_local_hint: 'A palavra-passe nunca sai deste dispositivo. Sem conta no servidor.',
  auth_create_identity: 'Criar identidade',
  auth_accept_legal_err: 'Aceite a Privacidade e os Termos para continuar',
  auth_generating_keys: 'A gerar chaves e sessão…',
  auth_generating_identity: 'A gerar identidade anónima…',
  auth_generating_detail: 'Chaves ECDH · alcunha · sessão socket · código ZN-',
  auth_you_are: 'É',
  auth_daily_suffix_hint: 'O sufixo diário muda a cada dia UTC. Para emparelhar, use o código ZN- no Início.',
  auth_enter: 'Entrar no ZION',
  auth_starting: 'A iniciar…',
  auth_restore_title: 'Restaurar cópia de segurança',
  auth_restore_hint: 'Já tem uma cópia de segurança encriptada? Recupere identidade, contactos e chats (ex.: após limpar a cache).',
  auth_restore_file: 'Ficheiro de cópia (.enc / .enc.json)',
  auth_restore_pass: 'Frase-passe da cópia',
  auth_restore_pass_ph: 'Frase-passe usada na exportação',
  auth_restore_btn: 'Restaurar cópia',
  auth_restore_pick_file: 'Selecione um ficheiro de cópia (.enc ou .enc.json).',
  auth_restore_need_pass: 'Introduza a frase-passe.',
  auth_restoring: 'A restaurar…',
  auth_file_prefix: 'Ficheiro:',
  common_accept: 'Aceitar',
  common_reject: 'Rejeitar',
  common_cancel: 'Cancelar',
  common_accepting: 'A aceitar…',
  common_error: 'Erro',
  common_loading: 'A carregar…',
  common_send: 'Enviar',
  common_copied: 'Copiado ✓',
  common_copy_failed: 'Falha ao copiar',
  common_ok: 'OK',
  common_today: 'Hoje',
  common_yesterday: 'Ontem',
  common_sending: 'A enviar…',
  home_zn_midnight_hint: 'Muda à meia-noite UTC (em {h}h {m}m)',
  home_temp_empty: 'Sem chats temporizados. Toque em ⏱ num contacto para iniciar um.',
  home_unread_aria: '{count} mensagens',
  home_temp_waiting: 'A aguardar aceitação…',
  home_temp_expires: 'Chat temporizado · expira em {remaining}',
  home_temp_cancel: 'Cancelar',
  home_temp_fallback_label: 'chat temporizado',
  home_temp_invite_title: '⏱ Convite para chat temporizado',
  home_temp_invite_body: '{nick} quer um chat efémero ({duration}).',
  home_temp_invite_hint: 'Aceite para começar a trocar mensagens que desaparecerão ao expirar.',
  home_temp_accept: 'Aceitar',
  home_temp_reject: 'Rejeitar',
  home_temp_accepting: 'A aceitar…',
  home_contacts_empty: 'Sem contactos. Partilhe o seu código ZN- ou QR para emparelhar.',
  home_temp_chat_aria: 'Chat temporizado',
  home_btn_pair_title: 'Emparelhar',
  home_btn_settings_title: 'Definições',
  home_zn_title: 'Código ZN- de hoje',
  home_btn_copy_zn: 'Copiar ZN-',
  home_btn_open_pair: 'QR de emparelhamento',
  home_section_temp: 'Chats temporizados',
  home_section_chat: 'Chats',
  home_loading: 'A carregar…',
  home_pair_zn_title: 'Emparelhar com código ZN-',
  home_btn_zn_pair: 'Enviar pedido',
  home_copied: 'Copiado ✓',
  home_copy_failed: 'Falha ao copiar',
  home_pair_request_title: 'Pedido de contacto',
  home_pair_request_body: '{name} quer conversar.',
  home_pair_reject: 'Rejeitar',
  home_pair_accept: 'Aceitar',
  home_pair_accepting: 'A aceitar…',
  home_pair_accept_failed: 'Falha na aceitação',
  home_zn_digits_err: 'Introduza os 5 dígitos após ZN-.',
  home_sending: 'A enviar…',
  chat_rename: 'Renomear',
  chat_rename_matrix: '[RENOMEAR]',
  chat_rename_title: 'Renomear contacto',
  chat_menu_title: 'Opções do chat',
  chat_loading: 'A carregar mensagens…',
  chat_reply_to: 'Responder a',
  chat_cancel_title: 'Cancelar',
  chat_voice_lock_hint: 'Deslize para cima para bloquear a gravação',
  chat_voice_locked: 'Gravação bloqueada — toque em Concluído',
  chat_voice_stop: 'CONCLUÍDO',
  chat_voice_stop_title: 'Concluído',
  chat_voice_preview_label: 'Pré-visualização de voz — ouça antes de enviar',
  chat_voice_send: 'ENVIAR',
  chat_voice_send_title: 'Enviar',
  chat_timer_label: 'Temporizador',
  chat_timer_title: 'Temporizador de mensagem',
  chat_timer_off: 'DESLIGADO',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Manter premido para gravar',
  chat_voice_hold_title: 'Manter premido para gravar',
  chat_doc: 'Doc',
  chat_doc_title: 'Documento',
  chat_attach_title: 'Anexos',
  chat_input_placeholder: 'Mensagem encriptada E2E…',
  chat_send: 'Enviar',
  chat_rename_modal_title: 'Renomear contacto',
  chat_rename_nickname: 'Alcunha: @{nick}',
  chat_rename_placeholder: 'Nome personalizado',
  chat_rename_cancel: 'Cancelar',
  chat_rename_save: 'Guardar',
  chat_action_reply: '↩ Responder',
  chat_action_copy: '⎘ Copiar',
  chat_action_delete_me: '🗑 Eliminar para mim',
  chat_action_delete_all: '🗑 Eliminar para todos',
  chat_action_cancel: 'Cancelar',
  chat_menu_clear_me: '🗑 Limpar chat (só para mim)',
  chat_menu_clear_all: '🗑 Eliminar chat para todos',
  chat_menu_cancel: 'Cancelar',
  chat_doc_send_title: 'Enviar documento',
  chat_doc_default_name: 'documento',
  chat_doc_send_hint: 'O ficheiro será comprimido, encriptado E2E e enviado. Máx. 5 MB.',
  chat_doc_cancel: 'Cancelar',
  chat_doc_send_encrypted: 'Enviar encriptado',
  chat_doc_too_large: '⚠️ FICHEIRO DEMASIADO GRANDE: O limite máximo de segurança para documentos é 5 MB.',
  chat_doc_unsupported: 'Tipo de documento não suportado.',
  chat_copy_failed: 'Falha ao copiar',
  chat_confirm_delete_me: 'Eliminar esta mensagem apenas para si?',
  chat_confirm_delete_all: 'Eliminar esta mensagem para todos?',
  chat_confirm_clear_all: 'Eliminar todo o chat para todos? Esta ação é irreversível.',
  chat_confirm_clear_me: 'Limpar o chat apenas para si?',
  chat_jump_new: '↓ Novas mensagens',
  chat_empty: 'Sem mensagens. Escreva algo para começar.',
  chat_voice_err_short: 'Mensagem de voz demasiado curta (mínimo 1 segundo).',
  chat_voice_err_long: 'Mensagem de voz demasiado longa (máximo 2 minutos).',
  chat_voice_err_large: 'Mensagem de voz demasiado grande (máx. 3 MB).',
  chat_voice_err_start: 'Não foi possível iniciar a gravação de voz.',
  chat_destroyed: '✉ Mensagem lida e destruída',
  chat_destroyed_title: 'Mensagem lida e destruída',
  chat_hold_options: 'Manter premido para opções',
  chat_reply_fallback: 'Mensagem',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'O código ZN- muda à meia-noite UTC (em {h}h {m}m).',
  pair_copied: 'Copiado ✓',
  pair_copy_failed: 'Falha ao copiar',
  pair_title: 'Emparelhamento',
  pair_zn_title: 'O seu código ZN- de hoje',
  pair_btn_copy_zn: 'Copiar código ZN-',
  pair_tab_mine: 'O meu QR',
  pair_tab_scan: 'Digitalizar / ZN-',
  pair_qr_aria: 'QR de emparelhamento',
  pair_expires_in: 'Expira em',
  pair_btn_copy_payload: 'Copiar payload',
  pair_btn_regen_qr: 'Regenerar QR',
  pair_qr_hint: 'Mostre este QR ao outro dispositivo. Válido por 10 minutos — compatível com a app Android.',
  pair_expired: 'expirado',
  pair_contact_zn_title: 'Código ZN- do contacto',
  pair_zn_prefix_hint: 'O prefixo <strong>ZN-</strong> já está definido — introduza apenas as 5 letras/dígitos.',
  pair_btn_zn_request: 'Enviar pedido ZN-',
  pair_paste_title: 'Ou cole um QR ZION1::',
  pair_paste_hint: 'Cole um payload <code>ZION1::</code> ou carregue uma foto do QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'De foto / câmara',
  pair_btn_connect_qr: 'Ligar com QR',
  pair_zn_digits_err: 'Introduza os 5 dígitos após ZN-.',
  pair_sending: 'A enviar pedido…',
  pair_reading_qr: 'A ler QR…',
  pair_qr_not_found: 'Código QR não encontrado na imagem.',
  pair_zn_read_ok: 'Código ZN- lido — confirme com Enviar pedido.',
  pair_qr_read_ok: 'QR lido — confirme com Ligar com QR.',
  pair_qr_read_err: 'Erro ao ler QR.',
  settings_identity_hint: 'A palavra-passe e as chaves permanecem neste browser. Sem conta no servidor.',
  settings_btn_add_home: 'Guia Adicionar ao Ecrã Inicial',
  settings_devices_title: 'Dispositivos ligados',
  settings_devices_hint: 'Multi-dispositivo Zero-Knowledge: as chaves viajam encriptadas E2E. O servidor é apenas um retransmissor.',
  settings_btn_link_device: 'Ligar novo dispositivo',
  settings_btn_sync_pc: 'Sincronizar histórico do PC',
  settings_no_devices: 'Sem dispositivos ligados.',
  settings_device_self: 'este dispositivo',
  settings_version_prefix: 'Versão:',
  settings_ios_push_hint: '<strong>iPhone:</strong> notificações = PWA do Ecrã Inicial + Banner/Som LIGADO. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Forçar atualização da app',
  settings_updating: 'A atualizar…',
  settings_push_mode_prefix: 'Modo:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> as notificações só funcionam ao abrir o ZION a partir do ícone do Ecrã Inicial (Partilhar → Adicionar ao Ecrã Inicial). No Safari normal <em>não</em> estão disponíveis — mesmo no iOS 17. Após instalar no Ecrã Inicial, volte aqui e toque em Ativar notificações.',
  settings_btn_enable_push: 'Ativar notificações push',
  settings_btn_desktop_notify: 'Notificações de desktop (PC)',
  settings_btn_disable_push: 'Desativar notificações',
  settings_desktop_requesting: 'A solicitar permissão de desktop…',
  settings_desktop_ok: 'Notificações de desktop ativas (som + popup quando chega uma mensagem).',
  settings_desktop_denied: 'Permissão negada ou não suportada.',
  settings_push_no_session: 'Sessão não pronta.',
  settings_push_requesting: 'A solicitar permissão…',
  settings_push_active: 'Notificações ativas.',
  settings_push_disabled: 'Notificações desativadas.',
  settings_theme_hint: 'Os mesmos temas da app ZION Android.',
  settings_theme_recommended: 'Recomendado',
  settings_backup_hint: 'Ficheiro JSON encriptado com uma frase-passe (compatível com o formato Android v2). Guarde-o no seu PC: contactos, chats e identidade web.',
  settings_backup_pass_label: 'Frase-passe da cópia',
  settings_backup_pass_ph: 'Frase-passe dedicada (mín. 8 caracteres)',
  settings_btn_export_backup: 'Exportar cópia',
  settings_backup_file_label: 'Restaurar a partir de ficheiro',
  settings_backup_import_pass_label: 'Frase-passe da cópia',
  settings_backup_import_pass_ph: 'Frase-passe usada na exportação',
  settings_btn_import_backup: 'Restaurar cópia',
  settings_backup_file_prefix: 'Ficheiro: {name}',
  settings_backup_pass_min: 'A frase-passe deve ter pelo menos 8 caracteres.',
  settings_backup_creating: 'A criar cópia…',
  settings_backup_pick_file: 'Selecione um ficheiro de cópia (.enc ou .enc.json).',
  settings_backup_need_pass: 'Introduza a frase-passe da cópia.',
  settings_backup_restoring: 'A restaurar…',
  settings_backup_overwrite_confirm: 'Substituir dados locais?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minutos',
  temp_duration_10m: '10 minutos',
  temp_duration_15m: '15 minutos',
  temp_duration_30m: '30 minutos',
  temp_duration_1h: '1 hora',
  temp_duration_6h: '6 horas',
  temp_duration_24h: '24 horas',
  temp_duration_7d: '7 dias',
  temp_remaining_expired: 'Expirado',
  temp_remaining_days: '{days}d {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Chat temporizado · mensagens efémeras',
  temp_empty: 'Sem mensagens efémeras.',
  temp_empty_hint: 'Escreva uma mensagem efémera. Desaparecerá quando o temporizador expirar.',
  temp_input_placeholder: 'Mensagem efémera…',
  temp_send: 'Enviar',
  temp_waiting_accept: 'A aguardar que {name} aceite o chat temporizado…',
  temp_waiting_placeholder: 'A aguardar aceitação…',
  temp_expires_in: 'Expira em {remaining}',
  temp_duration_title: 'Chat temporizado',
  temp_duration_with: 'Com {name}',
  temp_duration_hint: 'Escolha a duração — o chat desaparecerá de ambos os dispositivos.',
  temp_sending_invite: 'A enviar convite…',
  voice_lock_hint: 'Deslize para cima para bloquear a gravação',
  voice_locked: 'Gravação bloqueada — toque em Concluído',
  add_home_title: 'Adicionar ao Ecrã Inicial (iPhone / iPad)',
  add_home_guide_title: 'Guia Safari',
  add_home_step1: 'Abra o <strong>Safari</strong> nesta página (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Toque em <strong>Partilhar</strong> (quadrado com uma seta para cima)',
  add_home_step3: 'Escolha <strong>Adicionar ao Ecrã Inicial</strong>',
  add_home_step4: 'Abra o ZION a partir do <strong>ícone</strong> — não a partir de um separador do Safari',
  add_home_hint: 'No iOS/iPadOS 16.4+ a app do Ecrã Inicial suporta notificações Web Push e o teclado do chat. Após instalar, vá a <strong>Definições → Ativar notificações</strong>.',
  add_home_btn_continue: 'Entendido — continuar',
  add_home_btn_skip: 'Ignorar por agora',
  search_title: 'Pesquisar com código ZN-',
  search_label: 'Código ZN- diário',
  search_placeholder: 'ZN-123456',
  search_btn: 'Pesquisar',
  search_hint: 'Introduza o código ZN- do contacto. Sem pesquisa por alcunha — a identidade é apenas local.',
  search_format_err: 'Formato: ZN-123456',
  search_resolving: 'A resolver código…',
  search_invalid_code: 'Código inválido — peça um ZN- atualizado (reabra o ZION no dispositivo da outra pessoa)',
  search_session_found: 'sessão encontrada',
  search_tap_to_send: 'Toque para enviar pedido',
  search_socket_not_ready: 'Sessão socket não pronta',
  search_request_sent: 'Pedido enviado ✓',
  search_request_failed: 'Falha no envio',
  license_title: 'Ativação de licença Web / iPhone',
  license_heading: 'Licença',
  license_heading_updated: 'Termos atualizados',
  license_hint: 'Introduza o código <strong>ZION-XXXX-XXXX-XXXX</strong> adquirido em zionyx.ch. Será ligado a este browser (chave local).',
  license_code_label: 'Código de licença',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Ativar licença',
  license_beta_hint: 'Beta web: use uma licença iPhone dedicada se disponível.',
  license_accept_legal_err: 'Aceite a Privacidade e os Termos para continuar',
  license_need_code: 'Introduza o código de licença',
  license_verifying: 'A verificar licença…',
  license_invalid_or_used: 'Licença inválida ou já usada noutro dispositivo',
  license_active: 'Licença ativa ✓',
  license_err_not_found: 'Código de licença inválido',
  license_err_conflict: 'Licença já ligada a outro dispositivo',
  license_err_rate_limit: 'Demasiadas tentativas — aguarde um minuto',
  license_err_generic: 'Erro de licença',
  link_device_title: 'Ligar novo dispositivo',
  link_device_hint: 'No seu <strong>PC</strong>, abra Definições → Ligar novo dispositivo: verá o <strong>QR verde</strong>. Depois digitalize-o abaixo (câmara ou foto).',
  link_device_status_ready: '[PRONTO]',
  link_device_upload_label: 'Carregar foto do QR',
  link_device_btn_camera: 'Abrir câmara / galeria',
  link_device_placeholder: 'Ligação QR ou payload…',
  link_device_btn_send_vault: 'Enviar cofre encriptado',
  link_device_err_invalid_qr: 'QR inválido ou expirado.',
  link_device_status_invalid: '[QR INVÁLIDO]',
  link_device_status_sync_complete: '[SINCRONIZAÇÃO CONCLUÍDA]',
  link_device_status_transfer_failed: '[TRANSFERÊNCIA FALHOU]',
  link_device_status_qr_detected: '[QR DETETADO — A TRANSFERIR...]',
  link_device_status_tap_camera: '[TOQUE NO BOTÃO VERDE — CÂMARA DO IPHONE]',
  link_device_status_use_camera_below: '[USE A CÂMARA / GALERIA ABAIXO]',
  link_device_status_point_camera: '[APONTE A CÂMARA PARA O QR DO PC...]',
  link_device_status_decoding: '[A DECODIFICAR QR...]',
  link_device_status_qr_not_found: '[QR NÃO ENCONTRADO]',
  link_device_status_decode_failed: '[FALHA NA DECODIFICAÇÃO]',
  link_device_status_opened_from_qr: '[ABERTO A PARTIR DO QR — A INICIAR...]',
  link_recv_title: 'Ligar a partir do telemóvel',
  link_recv_hint_compact:
    'Digitalize este <strong>QR verde</strong> com o telemóvel (Definições → Ligar novo dispositivo). O vault é encriptado ponta a ponta.',
  link_recv_hint_auth:
    'Já tem ZION no telemóvel? Digitalize este QR com a <strong>Câmara</strong> — o PC liga-se e inicia sessão automaticamente.',
  link_recv_qr_alt: 'QR de ligação de dispositivo',
  link_recv_copy_link: 'Copiar ligação',
  link_recv_awaiting: '[À ESPERA DO SCAN DO TELEMÓVEL — TÚNEL ABERTO...]',
  link_recv_failed: '[EMPARELHAMENTO FALHOU]',
  link_recv_tunnel_lost:
    'Túnel interrompido — o vault pode ainda estar em trânsito. Tente digitalizar o QR novamente.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nova mensagem encriptada',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Mensagem efémera',
  force_update_title: '🚨 ATUALIZAÇÃO CRÍTICA OBRIGATÓRIA — Para continuar a usar o Zionyx em segurança, deve transferir a versão mais recente.',
  force_update_desc: 'O cliente instalado não é compatível com a versão mínima ativa no servidor.',
  force_update_versions: 'Instalada: v{current} · Necessária: v{required}',
  force_update_btn: 'ATUALIZAR AGORA',
}
